import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Observable } from 'rxjs';
export interface TableElement {  
  customerID: number | string;  
  customerName: string;  
  customerContactName: string;  
  customerContactEmail: string;  
  source: string; 
  iconSets: string;
  disabled?:boolean;
  internalContact?: boolean;
 
}
export const ELEMENT_DATA:TableElement[] =[]
@Injectable({
  providedIn: 'root'
})
export class NotificationAddRecipientService {
  public list: TableElement[] = ELEMENT_DATA;
  list$: BehaviorSubject<TableElement[]> = new BehaviorSubject(this.list);
  
  public addRecipientsControls= new Subject();
  public constructor(){}
  update(index, field, value) {
   this.list = this.list.map((element, i) => {
      if (index === i) {
        return {
          ...element,
          [field]: value
        };
      }
      return element;
    });
    this.list$.next(this.list);
  }
  changeUpdate(index, ele) {
    this.list = ele;
    this.list$.next(this.list);
  }
  add(){
    let naobj= {
      customerID:"",
      customerName:"",
      customerContactName:"",
      customerContactEmail:"",
      source:"",
      iconSets: 'yes-No-icon',
      internalContact: false,
   }
    this.list.push(naobj);
    this.list$.next(this.list);
  }

  addRecipientsList(notificationData): Observable<any>{
    // console.log(this.list$,this.list);
    let newAddRecipientsList:any = this.list.map(ele=>{
      let dataToSend ={
        "CustomerContactEmail": ele['customerContactEmail'], 
        "NotificationId": notificationData.NotificationId,
        "CustomerId": ele['customerID'],
        "CustomerContactName": ele['customerContactName'],
        "LocalId": notificationData.LocalId,
        "Type": notificationData.Type || '', 
        "CustomerName": ele['customerName'],
        "DataSource": ele['source'],
        "Title": notificationData.Title || '',
        "Status": "",
        "InternalContact": ele['internalContact'] === true
      }
      return dataToSend;
    })
    // console.log("data sending to API :-", newAddRecipientsList);
    
    // this.list.length = 0;
    // this.list$.next(this.list);
    return newAddRecipientsList;
  }
}